import template from './chartDiagram.html';

export const chartDiagramComponent = {
  name: 'chartDiagramComponent',
  restrict: 'E',
  transclude: true,
  template,
  bindings: {
    onToggleFilter: '&',
    status: '<'
  }
};
